import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { ProductivityService } from 'src/app/services/productivity-service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts';
import { MatDialog } from '@angular/material/dialog';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import { ButtonViewRendererComponent } from 'src/app/components/button-view-render.components';
import { DatePipe } from '@angular/common';
import { RMDashboardService } from '../../services/rm-dashboard.service';
import Drilldown from 'highcharts/modules/drilldown';
import More from 'highcharts/highcharts-more';
import Exporting from 'highcharts/modules/exporting';
import { ManagerExecutionService } from 'src/app/services/manager.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Options } from 'highcharts';
import { DtServiceService } from 'src/app/services/dtService.service';
import { PrevConfigurationService } from 'src/app/services/prev-configuration.service';
import { Multilingual } from 'src/app/services/multilingual';
import { AGGridUTCTOLocalDateService } from 'src/app/services/aggrid-utc-to-local-date.service';
import * as _ from 'lodash';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { BaseApi } from 'src/backend/api/base-api';
import { RMconfigurationService } from 'src/app/services/rmconfiguration.service';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
More(Highcharts);
Drilldown(Highcharts);
Exporting(Highcharts);
@Component({
  selector: 'app-kpi-masters-dashboard',
  templateUrl: './kpi-masters-dashboard.component.html',
  styleUrls: ['./kpi-masters-dashboard.component.scss'],
})
export class KpiMastersDashboardComponent implements OnInit {
  @ViewChild('imageZoomModel') private imageZoomModel!: TemplateRef<any>;
  @ViewChild('popupViewModal') private popupViewModal!: TemplateRef<any>;
  @ViewChild('breakDownDialog') private breakDownDialog!: TemplateRef<any>;
  @ViewChild('RepeatedBD') private RepeatedBD!: TemplateRef<any>;
  @ViewChild('MTTR') private MTTR!: TemplateRef<any>;
  @ViewChild('MTBF') private MTBF!: TemplateRef<any>;
  @ViewChild('MajorBD') private MajorBD!: TemplateRef<any>;
  @ViewChild('RepeatedDefects') private RepeatedDefects!: TemplateRef<any>;
  @ViewChild('MajorStops') private MajorStops!: TemplateRef<any>;
  @ViewChild('allSelectedUnit') private allSelectedUnit: any;
  @ViewChild('allSelectedLine') private allSelectedLine: any;

  startDate = new FormControl(moment());
  endDate = new FormControl(moment());
  public date: moment.Moment | undefined;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment | undefined;
  public maxDate: moment.Moment | undefined;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  filteredGroups: any;
  filteredPlants: any;
  filteredLines: any;
  filteredUnits: any;
  filteredComponents: any;
  // IsAccess: any;
  // IsWrite: any;
  GroupList!: any[];
  PlantList1!: any[];
  lineList!: any[];
  unitList!: any[];
  componentList!: any;
  permisson!: any;
  CLLDashboardForm!: FormGroup;
  TotalDefects!: any;
  TotalDefecteSolved!: any;
  CILAdherence!: any;
  TotalDefectsPerc!: any;
  CILTask!: any;
  key: any;
  dashboardData!: any;
  chartCILTask!: Chart;
  chartCILType!: Chart;
  chartCILTool!: Chart;
  highCharts: any;
  image!: any;
  currentImagePath!: any;
  defaultExcelExportParams: any;
  frameworkComponents: any;
  WOStatus: any[];

  rowData!: any[];
  columnDefs!: any[];
  gridApi: any;
  gridColumnApi: any;
  languageDir = 'ltr';
  langObj: any = {};
  /** i18n section shared by the PM pages. */
  private readonly PAGE = 'PM';
  moduleId!: any;
  pageId!: any;
  gridOptions: any = {
    defaultColDef: {
      rowHeight: 45,
      rowStyle: {
        'border-bottom': 'white 10px solid',
        'border-top': 'white 10px solid',
        'max-height': '50px',
      },
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- HERE
      minWidth: 225,
      filter: 'agSetColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    // headerHeight: 150,
    popupParent: document.querySelector('body'),
    // floatingFilter: true,
  };
  // iconUrl
  menuRedIconUrl = 'assets/images/menu-bottom-red-icon.png';
  menuGreenIconUrl = 'assets/images/menu-bottom-green-icon.png';
  unitPickerIsOpen: boolean = false;
  isPickFromUnit: boolean = false;

  HeaderData: any = {
    Line: '',
    Unit: '',
    displayMachine: '',
    StartDate: new Date(
      moment().subtract(1, 'd').set('hour', 6).set('minutes', 0).toString()
    ),
    EndDate: new Date(),
  };
  HeaderForm: any;
  TotalWO: any = 0;
  ClosedWO: any = 0;
  CompletedWO: any = 0;
  OpenedWO: any = 0;
  MTTRDays: any = 0;
  MTTRHours: any = 0;
  MTTRMinutes: any = 0;
  MTBFDays: any = 0;
  MTBFHours: any = 0;
  MTBFMinutes: any = 0;
  UsedSpareParts: any = 0;
  TreeData: any = [];

  MajorBDValues: any = 0;
  TotalBDChartValues: any = 0;
  MinorBDChartValues: any = 0;
  ModerateBDChartValues: any = 0;
  MajorBDChartValues: any = 0;
  MajorBDRowData: any[];
  MTTRValues: any = 0;
  MTBFValues: any = 0;
  minorStopsValues: any = 0;
  repeatedBDValues: any = 0;
  RepeatedDefectsValues: any = 0;
  MDTTime: any = 0;
  UnitsInGroup: any = [];
  PlantsInGroup: any = [];
  UnitsByLine: any = [];
  ComponentByUnit: any = [];

  chartMachine!: Chart;
  chartComponent!: Chart;
  isGreenMark!: boolean;
  selectedDate = 'Today';
  filteredDate: any[];
  drilldownData: any;
  spinnerText: string = '';
  userList: any = [];
  ChartName: any;
  isGreenOpenMark!: boolean;
  isGreenCompleteMark!: boolean;
  isGreenCloseMark!: boolean;
  openedPercentage: any;
  completedPercentage: any;
  closedPercentage: any;
  minorArr: any = [];
  moderateArr: any = [];
  majorArr: any = [];
  chartMinor!: Chart;
  chartModerate!: Chart;
  chartMajor!: Chart;
  isMinorChart: boolean = false;
  isModerateChart: boolean = false;
  isMajorChart: boolean = false;
  options: Options;
  mttrMonthly: any;
  mttrTechinicianLevel: any;
  mttrCategory: any;
  mttr: any;
  mtbfMonthly: any;
  mtbfMachineLevel: any;
  mtbfCategory: any;
  mtbf: any;
  minorStopsCategory: any;
  minorStopsMachineLevel: any;
  minorstopsSubAssemblyLevel: any;
  updt: any;
  KPIMasterCardData: any;
  majorBDMachineLevel: any;
  bdCategory: any;
  totalBreakdowns: any;
  majorBDSubAssemblyLevel: any;
  totalBDComponentLevel: Chart;
  plantList: any;
  plantTempList: any;
  majorBDMachineLevelData: any = [];
  subAssemblyData: any = [];
  ComponentName: any = [];
  FailureName: any[];
  bdCategoryData: any[] = [];
  totalBreakdownsoptions: any;
  bdCategoryoptions: any;
  majorBDMachineLeveloptions: any;
  majorBDSubAssemblyLeveloptions: any;
  totalBDComponentLeveloptions: any;
  rawmajorBDMachineLevelData: any[];
  rawsubAssemblyData: any[];
  rawComponentName: any[];
  rawFailureName: any[];
  rawbdCategoryData: any[];
  rawTechnicianName: any[];
  majorBDMachineLevelLabelData: any = [];
  LineList: any = [];
  LineFilterList: any = [];
  majorBDSubAssemblyLevelLabel: any = [];
  majorBDSubAssemblyLevelData: any = [];
  totalBDComponentLevelLabel: any = [];
  mttrTechnicianLevelLabel: any = [];
  totalBDComponentLevelData: any = [];
  mttrTechnicianLevelData: any = [];
  RepeatedBDOptions: any;

  repeatedBDChart: Chart;
  mttrMonthlyValues: any = [];
  mttrCategorySumValue: any = [];
  minorCategoryValues: any = [];
  minorCategoryLabels: any = [];
  minorMonthlyValues: any = [];
  minorStopsCategoryChart: Chart;
  minorStopsMonthlyChart: Chart;
  repeatedBDLabels: any = [];
  repeatedBDData: any = [];
  lang: any;
  isAccess = ApplicationPermission.KPI_MASTER_DASHBOARD_ACCESS;
  isWrite = ApplicationPermission.KPI_MASTER_DASHBOARD_CREATE;
  isUpdate = ApplicationPermission.KPI_MASTER_DASHBOARD_UPDATE;
  isDelete = ApplicationPermission.KPI_MASTER_DASHBOARD_DELETE;
  plantSession: any;
  groupSession: any;
  userSession: any;
  majorMonthlyValues: any = [];
  majorCategoryValues: any = [];
  majorStopsCategoryChart: Chart;
  majorStopsMonthlyChart: Chart;
  constructor(
    private productivityservice: ProductivityService,
    public translater: TranslaterService,
    public translate: TranslateService,
    private toaster: ToastrService,
    public router: Router,
    private userService: UserManagementService,
    private enterpriseGroupService: EnterPriseGroupService,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe,
    private pmDashboardService: RMDashboardService,
    private rmconfigurationService: RMconfigurationService,
    private fb: FormBuilder,
    public managerExecutionService: ManagerExecutionService,
    private dialog: MatDialog,
    private baseApi: BaseApi,
    private dtService: DtServiceService,
    public agGridUTCTOLocalDate: AGGridUTCTOLocalDateService,
    private prevConfigurationService: PrevConfigurationService,
    private employeeService: EmployeeService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      // Repaint from the JSON files at once; getLangWords() repaints again
      // when the database tags arrive. Without this the page only changed
      // language after a reload.
      this.langObj = null;
      this.applyLanguageToView();
      this.getLangWords();
    });
    this.filteredDate = [
      { value: 'Today' },
      { value: 'Yesterday' },
      { value: 'Last Week' },
      { value: 'Last Month' },
    ];

    this.defaultExcelExportParams = {
      addImageToCell: function (
        rowIndex: number,
        col: any,
        value: any,
        callback: any
      ) {
        if (col.colId === 'PreImage' || col.colId === 'PostImage') {
        } else {
          return;
        }
      },
    };
    this.frameworkComponents = {
      buttonRenderer: ButtonViewRendererComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Unit',
        field: 'PU_Desc',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Assembly',
        field: 'Assbly_Desc',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Sub Assembly',
        field: 'SAsbly_Desc',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Component',
        field: 'ComponentName',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'WO ID',
        field: 'OperatorExecutionWOID',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'WO Description',
        field: 'Remark',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'WO Type',
        field: 'WOName',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Failure Mode',
        field: 'FailureName',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      //  { headerName: 'Unit ID', field: 'UnitId', headerValueGetter: this.localizeHeader.bind(this) },
      {
        headerName: 'WO Status',
        field: 'WOStatus',
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },

      {
        headerName: 'Created AT',
        field: 'CreatedAt',
        type: 'date',
        cellRenderer: function (params: any) {
          let html =
            params && params.value
              ? moment(params.value).format('DD/MM/YYYY hh:mm:ss a')
              : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'RepairTime',
        field: 'RepairTime',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Repair Time (min)',
        field: 'diffMins',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Start Time',
        field: 'StartTime',
        type: 'date',
        cellRenderer: function (params: any) {
          let html =
            params && params.value
              ? moment(params.value).format('DD/MM/YYYY hh:mm:ss a')
              : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
        hide: true,
      },
      {
        headerName: 'Complete Time',
        field: 'CompleteTime',
        type: 'date',
        cellRenderer: function (params: any) {
          let html =
            params && params.value
              ? moment(params.value).format('DD/MM/YYYY hh:mm:ss a')
              : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
        hide: true,
      },
      {
        headerName: 'Closed At',
        field: 'ClosedAt',
        type: 'date',
        cellRenderer: function (params: any) {
          let html =
            params && params.value
              ? moment(params.value).format('DD/MM/YYYY hh:mm:ss a')
              : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      // { headerName: 'Failure Name', field: 'FailureName', headerValueGetter: this.localizeHeader.bind(this) },
    ];
    this.defaultExcelExportParams = {
      addImageToCell: function (
        rowIndex: number,
        col: any,
        value: any,
        callback: any
      ) {
        if (col.colId === 'PreImage' || col.colId === 'PostImage') {
        } else {
          return;
        }
      },
    };
  }

  ngOnInit(): void {
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.userSession = this.baseApi.getUserSession();
    this.HeaderForm = this.fb.group({
      line: ['', Validators.required],
      unit: ['', Validators.required],
      displayMachine: ['', Validators.required],
      Date: ['', Validators.required],
      StartDate: [new Date(), Validators.required],
      EndDate: [new Date(), Validators.required],
    });
    this.getLangWords();
    this.getTreeMasterData();
    this.initform();
    this.getUserList();
  }
  initform() {
    this.HeaderData.Date = 'Today';
    this.HeaderData.ChartUnit = 0;
  }
  getUserList() {
    this.spinnerText = this.t('SpinnerFetchingUserData', 'Fetching User Data');
    this.spinner.show();
    this.employeeService.getAllEmployees().subscribe(
      (res: any) => {
        this.userList = res;
        this.spinner.hide();
      },
      (err: any) => {
        console.log(err);
        this.spinner.hide();
      }
    );
  }
  getTreeMasterData() {
    const data = {
      Groupcode: this.groupSession?.groupCode,
      Plantcode: this.plantSession?.plantCode,
    };
    const id = {
      value: 0,
    };
    this.spinner.show();
    this.prevConfigurationService.GetTreeMasterData(data).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.LineList = res.Line;
        this.LineFilterList = this.LineList.slice();
        this.HeaderForm.get('line')?.setValue(this.LineList.length > 0 ? [this.LineList[0]?.PL_Id] : this.HeaderForm.get('line')?.value);
        this.getUnits();
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(this.t('Error', 'Error'), error.ErrorMessage);
      }
    );
  }

  onLineChange(event: any) {
    this.HeaderData.Line = event.value;
    this.getUnits();
  }

  getUnits(): void {
    const plIdValue = this.HeaderForm.get('line')?.value.toString();
    const plIdArray = plIdValue.split(',');
    const filteredPlIdArray = plIdArray.filter(
      (value) => value.trim() !== 'ALL'
    );
    const filteredPlIdValue = filteredPlIdArray.join(',');
    const key = {
      PL_ID: filteredPlIdValue,
      PT_ID: this.HeaderForm.get('plant')?.value,
    };
    const id = {
      value: 0,
    };
    this.spinner.show();
    this.prevConfigurationService.getUnitByLineList(key).subscribe(
      (data: any) => {
        this.spinner.hide();
        this.unitList = data.lstUnit;
        this.filteredUnits = this.unitList.slice();
        this.HeaderForm.get('unit')?.setValue((this.LineList.length > 0 && this.unitList.length > 0) ? [this.unitList[0]?.PU_Id] : this.HeaderForm.get('unit')?.value);
        id.value = data.lstUnit[0].PU_Id;
        // if (this.unitList.length > 0) {
        //   this.HeaderForm.get('unit')?.setValue(0);
        //   this.filteredUnits = this.unitList.slice();
        //   // this.getKPIMastersData();
        // }
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(this.t('Error', 'Error'), error.message);
      }
    );
  }

  getUnitData() {
    const key = {
      PL_ID: this.HeaderData.Line,
      PlantCode: this.plantSession?.plantCode,
      userCode: this.userSession?.userCode,
    };
    this.spinner.show();
    this.rmconfigurationService.getUnitData(key).subscribe(
      (data: any) => {
        this.spinner.hide();
        this.unitList = data.lstUnit;
        this.filteredUnits = this.unitList.slice();
        this.HeaderForm.get('unit')?.setValue(this.unitList[0]?.PU_Id);
      },
      (error: any) => {
        this.spinner.hide();
        this.toaster.error(this.t('Error', 'Error'), error.message);
      }
    );
  }
  makeDatatoDay() {
    const stDT = new Date();
    stDT.setDate(stDT.getDate());
    stDT.setHours(6);
    stDT.setMinutes(0);
    stDT.setSeconds(0);

    const edDT = new Date();
    edDT.setDate(edDT.getDate());
    this.HeaderData.StartDate = stDT;
    this.HeaderData.EndDate = edDT;
  }

  openModal() {
    this.unitPickerIsOpen = true;
    this.isPickFromUnit = true;
  }

  setUnit(event: any) {
    this.unitPickerIsOpen = false;
    this.HeaderData.ChartUnit = 0;
    this.HeaderData.Line = 0;
    this.HeaderData.Unit = 0;
    this.HeaderData.Assembly = 0;
    this.HeaderData.SubAssembly = 0;
    this.HeaderData.Component = 0;
    this.HeaderData.displayMachine = '';

    this.HeaderData.displayMachine = event.displayMachine;
    if (event.Level == 'Line') {
      this.HeaderData.Line = event.line;
    } else if (event.Level == 'Unit') {
      this.HeaderData.Line = event.line;
      this.HeaderData.Unit = event.units;
    } else if (event.Level == 'Assembly') {
      this.HeaderData.Line = event.line;
      this.HeaderData.Unit = event.units;
      this.HeaderData.Assembly = event.assembly;
    } else if (event.Level == 'SubAssembly') {
      this.HeaderData.Line = event.line;
      this.HeaderData.Unit = event.units;
      this.HeaderData.Assembly = event.assembly;
      this.HeaderData.SubAssembly = event.subAssembly;
    } else if (event.Level == 'Component') {
      this.HeaderData.Line = event.line;
      this.HeaderData.Unit = event.units;
      this.HeaderData.Assembly = event.assembly;
      this.HeaderData.SubAssembly = event.subAssembly;
      this.HeaderData.Component = event.component;
    }
    setTimeout(() => {
      this.getKPIMastersData();
    }, 500);
  }

  /**
   * Resolve a label:  langObj (database)  ->  "PM.<key>"  ->  flat "<key>"
   * ->  the English fallback passed by the caller. All PM pages share the
   * "PM" i18n section.
   */
  public t(key: string, fallback: string): string {
    if (this.langObj && this.langObj[key]) {
      return this.langObj[key];
    }
    return this.lookup(this.PAGE + '.' + key) || this.lookup(key) || fallback;
  }

  private lookup(key: string): string | null {
    const value = this.translate.instant(key);
    if (typeof value === 'string' && value !== key) {
      return value;
    }
    if (value && typeof value === 'object' && typeof value.title === 'string') {
      return value.title;
    }
    return null;
  }

  public localizeHeader(parameters: any) {
    const colDef = parameters && parameters.colDef ? parameters.colDef : {};
    return this.getTransalatedValue(colDef.field, colDef.headerName);
  }

  /**
   * Header lookup: database first (keyed on the field name, as before), then
   * the JSON files (keyed on the readable header and its space-free form),
   * then the English header -- never the raw field name.
   */
  getTransalatedValue(value: string, headerLabel?: string): string {
    const compact = headerLabel ? headerLabel.replace(/\s+/g, '') : '';
    for (const candidate of [value, headerLabel, compact]) {
      if (candidate && this.langObj && this.langObj[candidate]) {
        return this.langObj[candidate];
      }
    }
    for (const candidate of [compact, headerLabel, value]) {
      if (!candidate) {
        continue;
      }
      const hit = this.lookup(this.PAGE + '.' + candidate) || this.lookup(candidate);
      if (hit) {
        return hit;
      }
    }
    return headerLabel ? headerLabel : value;
  }

  /** Repaint the grid without waiting for the database tag request. */
  private applyLanguageToView(): void {
    try {
      this.gridApi?.refreshHeader();
      this.gridApi?.refreshCells({ force: true });
    } catch (e) {
      // a destroyed grid must not break the language switch
    }
  }
  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find((x) => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
          ? 2
          : this.translate.currentLang === 'fr'
          ? 3
          : this.translate.currentLang === 'sp'
          ? 4
          : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      this.applyLanguageToView();
    }, () => {
      // the JSON files already carry the new language, keep the repaint
      this.applyLanguageToView();
    });
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  udpateNodeParentDetails() {
    if (this.TreeData && this.TreeData.length) {
      this.TreeData.forEach((group: any) => {
        if (group.children && group.children.length) {
          group.children.forEach((plant: any) => {
            plant.groupName = group.text;
            plant.groupId = group.PrimaryId;
            if (plant.children && plant.children.length) {
              plant.children.forEach((division: any) => {
                division.plantId = plant.PrimaryId;
                division.plantName = plant.text;
                division.groupName = group.text;
                division.groupId = group.PrimaryId;
                if (division.children && division.children.length) {
                  division.children.forEach((department: any) => {
                    department.divisionId = division.PrimaryId;
                    department.divisionName = division.text;
                    department.plantId = plant.PrimaryId;
                    department.plantName = plant.text;
                    department.groupId = group.PrimaryId;
                    department.groupName = group.text;
                    if (department.children && department.children.length) {
                      department.children.forEach((line: any) => {
                        line.departmentId = department.PrimaryId;
                        line.departmentName = department.text;
                        line.divisionId = division.PrimaryId;
                        line.divisionName = division.text;
                        line.plantId = plant.PrimaryId;
                        line.plantName = plant.text;
                        line.groupId = group.PrimaryId;
                        line.groupName = group.text;
                        if (line.children && line.children.length) {
                          line.children.forEach((unit: any) => {
                            unit.lineId = line.PrimaryId;
                            unit.lineName = line.text;
                            unit.departmentId = department.PrimaryId;
                            unit.departmentName = department.text;
                            unit.divisionId = division.PrimaryId;
                            unit.divisionName = division.text;
                            unit.plantId = plant.PrimaryId;
                            unit.plantName = plant.text;
                            unit.groupId = group.PrimaryId;
                            unit.groupName = group.text;
                            if (unit.children && unit.children.length) {
                              unit.children.forEach((assembly: any) => {
                                assembly.unitName = unit.text;
                                assembly.unitId = unit.PrimaryId;
                                assembly.lineId = line.PrimaryId;
                                assembly.lineName = line.text;
                                assembly.departmentId = department.PrimaryId;
                                assembly.departmentName = department.text;
                                assembly.divisionId = division.PrimaryId;
                                assembly.divisionName = division.text;
                                assembly.plantId = plant.PrimaryId;
                                assembly.plantName = plant.text;
                                assembly.groupId = group.PrimaryId;
                                assembly.groupName = group.text;
                                if (
                                  assembly.children &&
                                  assembly.children.length
                                ) {
                                  assembly.children.forEach(
                                    (subAssembly: any) => {
                                      subAssembly.assemblyName = assembly.text;
                                      subAssembly.assemblyId =
                                        assembly.PrimaryId;
                                      subAssembly.unitName = unit.text;
                                      subAssembly.unitId = unit.PrimaryId;
                                      subAssembly.lineId = line.PrimaryId;
                                      subAssembly.lineName = line.text;
                                      subAssembly.departmentId =
                                        department.PrimaryId;
                                      subAssembly.departmentName =
                                        department.text;
                                      subAssembly.divisionId =
                                        division.PrimaryId;
                                      subAssembly.divisionName = division.text;
                                      subAssembly.plantId = plant.PrimaryId;
                                      subAssembly.plantName = plant.text;
                                      subAssembly.groupId = group.PrimaryId;
                                      subAssembly.groupName = group.text;
                                      if (
                                        subAssembly.children &&
                                        subAssembly.children.length
                                      ) {
                                        subAssembly.children.forEach(
                                          (component: any) => {
                                            component.subAssemblyName =
                                              subAssembly.text;
                                            component.subAssemblyId =
                                              subAssembly.PrimaryId;
                                            component.assemblyName =
                                              assembly.text;
                                            component.assemblyId =
                                              assembly.PrimaryId;
                                            component.unitName = unit.text;
                                            component.unitId = unit.PrimaryId;
                                            component.lineId = line.PrimaryId;
                                            component.lineName = line.text;
                                            component.departmentId =
                                              department.PrimaryId;
                                            component.departmentName =
                                              department.text;
                                            component.divisionId =
                                              division.PrimaryId;
                                            component.divisionName =
                                              division.text;
                                            component.plantId = plant.PrimaryId;
                                            component.plantName = plant.text;
                                            component.groupId = group.PrimaryId;
                                            component.groupName = group.text;
                                          }
                                        );
                                      }
                                    }
                                  );
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
  }

  leftpad(val: any, resultLength = 2, leftpadChar = '0'): string {
    return (String(leftpadChar).repeat(resultLength) + String(val)).slice(
      String(val).length
    );
  }

  getMajorBD() {
    this.totalBreakdownsoptions = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.t('TotalBD', 'Total BD'),
      },
      colors: ['#ff914d'],
      xAxis: {
        categories: ['Total BD', 'Minor BD', 'Moderate BD', 'Major BD'],
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [
        {
          showInLegend: false,
          data: [
            this.TotalBDChartValues,
            this.MinorBDChartValues,
            this.ModerateBDChartValues,
            this.MajorBDChartValues,
          ],
        },
      ],
    } as any;
    let chart = new Chart(this.totalBreakdownsoptions);
    this.totalBreakdowns = chart;
    this.bdCategoryoptions = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      title: {
        text: this.t('BDCategory', 'BD Category'),
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '%',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: false,
        },
      },
      series: [
        {
          name: '',
          colorByPoint: true,
          data: this.bdCategoryData,
        },
      ],
    } as any;
    chart = new Chart(this.options);
    this.minorstopsSubAssemblyLevel = chart;

    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.t('MTTRTechnicianLevel', 'MTTR Technican Level'),
      },
      subtitle: {
        text: '',
      },
      colors: ['#08b051'],
      xAxis: {
        categories: [
          'C12',
          'C12-2',
          'C15',
          'HB2',
          'Presto 1',
          'Presto 2',
          'Lithoman 1',
          'LMN 2',
          'R702',
        ],
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: this.t('MTTRTechnician', 'MTTR Technican'),
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [
        {
          showInLegend: false,
          data: this.bdCategoryData,
        },
      ],
    } as any;
    chart = new Chart(this.bdCategoryoptions);
    this.bdCategory = chart;
    this.majorBDMachineLeveloptions = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.t('BDMachineLevel', 'BD Machine Level'),
      },
      subtitle: {
        text: '',
      },
      xAxis: {
        categories: this.majorBDMachineLevelLabelData,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          pointWidth: 50,
        },
      },
      series: [
        {
          color: '#1212d1',
          showInLegend: false,
          data: this.majorBDMachineLevelData,
        },
      ],
    } as any;
    chart = new Chart(this.majorBDMachineLeveloptions);
    this.majorBDMachineLevel = chart;

    this.majorBDSubAssemblyLeveloptions = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.t('BDSubAssemblyLevel', 'BD Sub Assembly Level'),
      },
      subtitle: {
        text: '',
      },
      xAxis: {
        categories: this.majorBDSubAssemblyLevelLabel,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          pointWidth: 50,
        },
      },
      series: [
        {
          color: '#6ce5e8',
          showInLegend: false,
          data: this.majorBDSubAssemblyLevelData,
        },
      ],
    } as any;
    chart = new Chart(this.majorBDSubAssemblyLeveloptions);
    this.majorBDSubAssemblyLevel = chart;

    this.totalBDComponentLeveloptions = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.t('BDComponentLevel', 'BD Component Level'),
      },
      subtitle: {
        text: '',
      },
      colors: ['#08b051'],
      xAxis: {
        categories: this.totalBDComponentLevelLabel,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {},
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          pointWidth: 50,
        },
      },
      series: [
        {
          showInLegend: false,
          data: this.totalBDComponentLevelData,
        },
      ],
    } as any;
    chart = new Chart(this.totalBDComponentLeveloptions);
    this.totalBDComponentLevel = chart;
  }
  getMTBF() {
    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.t('MTBFTotal', 'MTBF Total'),
      },
      colors: ['#ff914d'],
      xAxis: {
        categories: ['Total BD', 'Minor BD', 'Moderate BD', 'Major BD'],
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [{ showInLegend: false, data: [49.9, 71.5, 106, 4.4] }],
    } as any;
    let chart = new Chart(this.options);
    this.mtbf = chart;
    this.options = {
      chart: {
        zoomType: 'xy',
      },
      title: {
        text: this.t('MTBFMonthly', 'MTBF Monthly'),
      },
      subtitle: {
        text: '',
      },
      xAxis: [
        {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
          crosshair: true,
        },
      ],
      yAxis: [
        {
          // Primary yAxis
          labels: {
            format: '{value}',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          title: {
            text: '',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
        },
        {
          // Secondary yAxis
          title: {
            text: '',
            style: {
              color: Highcharts.getOptions().colors[0],
            },
          },
          labels: {
            format: '{value} ',
            style: {
              color: Highcharts.getOptions().colors[0],
            },
          },
          opposite: true,
        },
      ],
      tooltip: {
        shared: true,
      },
      legend: {
        layout: 'vertical',
        align: 'left',
        x: 120,
        verticalAlign: 'top',
        y: 100,
        floating: true,
        backgroundColor:
          Highcharts.defaultOptions.legend.backgroundColor || // theme
          'rgba(255,255,255,0.25)',
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: '',
          color: '#94a9de',
          showInLegend: false,
          type: 'column',
          yAxis: 1,
          data: this.mttrMonthlyValues,
          tooltip: {
            valueSuffix: ' ',
          },
        },
      ],
    } as any;
    chart = new Chart(this.options);
    this.mtbfMonthly = chart;
    this.options = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      title: {
        text: this.t('MTBFCategory', 'MTBF Category'),
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '%',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: this.t('Brands', 'Brands'),
          colorByPoint: true,
          data: this.mttrCategorySumValue,
        },
      ],
    } as any;
    chart = new Chart(this.options);
    this.mtbfCategory = chart;

    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.t('MTBFTechnicianLevel', 'MTBF Technican Level'),
      },
      subtitle: {
        text: '',
      },
      colors: ['#08b051'],
      xAxis: {
        categories: [
          'C12',
          'C12-2',
          'C15',
          'HB2',
          'Presto 1',
          'Presto 2',
          'Lithoman 1',
          'LMN 2',
          'R702',
        ],
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          showInLegend: false,
          data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4],
        },
      ],
    } as any;
    chart = new Chart(this.options);
    this.mtbfMachineLevel = chart;
  }
  getMinorStops() {
    this.options = {
      chart: {
        zoomType: 'xy',
      },
      title: {
        text: this.t('MajorMonthly', 'Major Monthly'),
      },
      subtitle: {
        text: '',
      },
      xAxis: [
        {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
          crosshair: true,
        },
      ],
      yAxis: [
        {
          // Primary yAxis
          labels: {
            format: '{value}',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          title: {
            text: '',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
        },
        {
          // Secondary yAxis
          title: {
            text: '',
            style: {
              color: Highcharts.getOptions().colors[0],
            },
          },
          labels: {
            format: '{value} ',
            style: {
              color: Highcharts.getOptions().colors[0],
            },
          },
          opposite: true,
        },
      ],
      tooltip: {
        shared: true,
      },
      legend: {
        layout: 'vertical',
        align: 'left',
        x: 120,
        verticalAlign: 'top',
        y: 100,
        floating: true,
        backgroundColor:
          Highcharts.defaultOptions.legend.backgroundColor || // theme
          'rgba(255,255,255,0.25)',
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          showInLegend: false,
          name: '',
          color: '#94a9de',
          type: 'column',
          yAxis: 1,
          data: this.majorMonthlyValues,
          tooltip: {
            valueSuffix: ' ',
          },
        },
      ],
    } as any;
    let chart = new Chart(this.options);
    this.majorStopsMonthlyChart = chart;
    this.options = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      title: {
        text: this.t('MajorCategory', 'Major Category'),
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '%',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: '',
          colorByPoint: true,
          data: this.majorCategoryValues,
        },
      ],
    } as any;
    chart = new Chart(this.options);
    this.majorStopsCategoryChart = chart;
  }
  getRepeatedBD() {
    this.RepeatedBDOptions = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.t('RepeatedBD', 'Repeated BreakDowns'),
      },
      subtitle: {
        text: '',
      },
      colors: ['#08b051'],
      xAxis: {
        categories: this.repeatedBDLabels,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          pointWidth: 50,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          showInLegend: false,
          data: this.repeatedBDData,
        },
      ],
    };
    let chart = new Chart(this.RepeatedBDOptions);
    this.repeatedBDChart = chart;
  }
  getRepeatedDefects() {}

  getMTTR() {
    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.t('MTTRTotal', 'MTTR Total'),
      },
      colors: ['#ff914d'],
      xAxis: {
        categories: ['Total BD', 'Minor BD', 'Moderate BD', 'Major BD'],
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          showInLegend: false,
          data: [
            this.TotalBDChartValues,
            this.MinorBDChartValues,
            this.ModerateBDChartValues,
            this.MajorBDChartValues,
          ],
        },
      ],
    } as any;
    let chart = new Chart(this.options);
    this.mttr = chart;
    this.options = {
      chart: {
        zoomType: 'xy',
      },
      title: {
        text: this.t('MTTRMonthly', 'MTTR Monthly'),
      },
      subtitle: {
        text: '',
      },
      xAxis: [
        {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
          crosshair: true,
        },
      ],
      yAxis: [
        {
          // Primary yAxis
          labels: {
            format: '{value}',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          title: {
            text: '',
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
        },
        {
          // Secondary yAxis
          title: {
            text: '',
            style: {
              color: Highcharts.getOptions().colors[0],
            },
          },
          labels: {
            format: '{value} ',
            style: {
              color: Highcharts.getOptions().colors[0],
            },
          },
          opposite: true,
        },
      ],
      tooltip: {
        shared: true,
      },
      legend: {
        layout: 'vertical',
        align: 'left',
        x: 120,
        verticalAlign: 'top',
        y: 100,
        floating: true,
        backgroundColor:
          Highcharts.defaultOptions.legend.backgroundColor || // theme
          'rgba(255,255,255,0.25)',
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          showInLegend: false,
          name: '',
          color: '#94a9de',
          type: 'column',
          yAxis: 1,
          data: this.mttrMonthlyValues,
          tooltip: {
            valueSuffix: ' ',
          },
        },
      ],
    } as any;
    chart = new Chart(this.options);
    this.mttrMonthly = chart;
    this.options = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      title: {
        text: this.t('MTTRCategory', 'MTTR Category'),
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '%',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: this.t('Brands', 'Brands'),
          colorByPoint: true,
          data: this.mttrCategorySumValue,
        },
      ],
    } as any;
    chart = new Chart(this.options);
    this.mttrCategory = chart;

    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.t('MTTRTechnician', 'MTTR Technician'),
      },
      subtitle: {
        text: '',
      },
      colors: ['#08b051'],
      xAxis: {
        categories: this.mttrTechnicianLevelLabel,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: this.t('MTTRTechnician', 'MTTR Technician'),
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          showInLegend: false,
          data: this.mttrTechnicianLevelData,
        },
      ],
    } as any;
    chart = new Chart(this.options);
    this.mttrTechinicianLevel = chart;
  }

  openMajorBD() {
    if (this.MajorBDValues === 0 && this.rowData.length == 0) {
      return;
    } else {
      let dialogRef = this.dialog.open(this.MajorBD, {
        width: '80%',
        height: '90%',
      });
      dialogRef.afterOpened().subscribe((result) => {
        this.getMajorBD();
      });
      dialogRef.afterClosed().subscribe((result) => {});
    }
  }
  openMTBF() {
    if (this.MTBFValues == 0) return;
    let dialogRef = this.dialog.open(this.MTBF, {
      width: '80%',
      height: '90%',
    });
    dialogRef.afterOpened().subscribe((result) => {
      this.getMTBF();
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  openMinorStops() {
    if (this.MajorBDChartValues == 0) return;
    let dialogRef = this.dialog.open(this.MajorStops, {
      width: '80%',
      height: '70%',
    });
    dialogRef.afterOpened().subscribe((result) => {
      this.getMinorStops();
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  openRepeatedBD() {
    if (this.repeatedBDValues == 0) {
      return;
    } else {
      let dialogRef = this.dialog.open(this.RepeatedBD, {
        width: '80%',
        height: '70%',
      });
      dialogRef.afterOpened().subscribe((result) => {
        this.getRepeatedBD();
      });
      dialogRef.afterClosed().subscribe((result) => {});
    }
  }
  openRepeatedDefects() {}
  openMTTR() {
    if (this.MTTRValues == 0) return;
    let dialogRef = this.dialog.open(this.MTTR, {
      width: '80%',
      height: '90%',
    });
    dialogRef.afterOpened().subscribe((result) => {
      this.getMTTR();
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  /// AG Grid
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.autoSizeAllColumns();
  }
  autoSizeAllColumns() {
    this.gridApi.setRowData(this.rowData);
    this.gridColumnApi.autoSizeAllColumns();
  }

  excelExport() {
    const params = {};
    this.agGridUTCTOLocalDate.excelExport(params);
    this.gridApi.exportDataAsExcel(params);
  }

  csvExport() {
    const params = {};
    this.agGridUTCTOLocalDate.csvExport(params);
    this.gridApi.exportDataAsCsv(params);
  }
  getKPIMastersData() {
    if (this.HeaderData.Plant == '') {
      return;
    } else {
      if(!this.HeaderForm.get('line').value || !this.HeaderForm.get('unit').value){
        return;
      }
      const plIdValue1 = this.HeaderForm.get('line')?.value.toString();
      const plIdArray1 = plIdValue1.split(',');
      const filteredPlIdArray1 = plIdArray1.filter(
        (value) => value.trim() !== 'ALL'
      );
      const filteredLines = filteredPlIdArray1.join(',');

      const plIdValue2 = this.HeaderForm.get('unit')?.value.toString();
      const plIdArray2 = plIdValue2.split(',');
      const filteredPlIdArray2 = plIdArray2.filter(
        (value) => value.trim() !== 'ALL'
      );
      const filteredUnits = filteredPlIdArray2.join(',');

      const data = {
        PLID: filteredLines,
        PUID: filteredUnits,
        plantcode: this.plantSession?.plantCode,
        groupcode: this.groupSession?.groupCode,
        dateStart: this.HeaderData.StartDate,
        dateEnd: this.HeaderData.EndDate,
      };

      this.spinner.show();
      this.rawsubAssemblyData = [];
      this.rawComponentName = [];
      this.rawTechnicianName = [];
      this.rawFailureName = [];
      this.rawbdCategoryData = [];
      this.MajorBDChartValues = 0;
      this.MinorBDChartValues = 0;
      this.ModerateBDChartValues = 0;
      this.TotalBDChartValues = 0;
      this.MajorBDRowData = [];

      this.pmDashboardService.getMainKPIDashboard(data).subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res) {
            this.KPIMasterCardData = res;
          }
          if (res.dtData && res.dtData.length > 0) {
            this.rowData = res.dtData;
            this.autoSizeAllColumns();
            this.MajorBDRowData = res.majorArr;
            for (const row of this.rowData) {
              if (row.CompleteTime && row.StartTime) {
                const completeTime = new Date(row.CompleteTime);
                const startTime = new Date(row.StartTime);
                const diffInMilliseconds =
                  completeTime.getTime() - startTime.getTime();

                const hours = Math.round(diffInMilliseconds / (1000 * 60 * 60));
                // const minutes = Math.round((diffInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
                //const minutes = Math.floor((diffInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
                const minutes1 = Math.floor(
                  (diffInMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
                );
                const totalSeconds = Math.floor(
                  (diffInMilliseconds % (1000 * 60)) / 1000
                );
                const minutes = minutes1 + Math.round(totalSeconds / 60);
                var ms = moment(row.CompleteTime).diff(moment(row.StartTime));
                // var ms = moment(row.StartTime).diff(moment(row.CompleteTime));
                var d = moment.duration(ms);
                var s =
                  Math.floor(d.asHours()) + moment.utc(ms).format(':mm:ss');
                row.RepairTime = s; // `${d.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
              } else row.RepairTime = '';
              row.WOStatus =
                row.WOStatus == '1'
                  ? 'Open'
                  : row.WOStatus == '2'
                  ? 'Close'
                  : row.WOStatus == '3'
                  ? 'Complete'
                  : row.WOStatus == '4'
                  ? 'Delay'
                  : 'In Progress';
            }
          } else {
            this.rowData = [];
            this.autoSizeAllColumns();
          }
          if (this.rowData && this.rowData.length) {
            this.rawmajorBDMachineLevelData = this.findOcc(
              this.rowData,
              'PU_Desc'
            );
            this.rawsubAssemblyData = this.findOcc(this.rowData, 'SAsbly_Desc');
            this.rawComponentName = this.findOcc(this.rowData, 'ComponentName');
            this.rawFailureName = this.findOcc(this.rowData, 'FailureName');
            this.rawbdCategoryData = this.findOcc(this.rowData, 'WOName');
            this.rawTechnicianName = this.findMTTRTechnicianData(
              this.rowData,
              'TechnicianName'
            );
            this.setData();
          }

          this.MajorBDValues = this.KPIMasterCardData.TotalBD;
          this.TotalBDChartValues = this.KPIMasterCardData.TotalBD;
          this.MTTRValues = this.KPIMasterCardData.MTTR;
          this.MTBFValues = this.KPIMasterCardData.MTBF;
          this.minorStopsValues = this.KPIMasterCardData.MinorStops;
          this.repeatedBDValues = this.KPIMasterCardData.RepeatedBD;
          this.RepeatedDefectsValues = this.KPIMasterCardData.RepeatedDefects;
          this.MinorBDChartValues = this.KPIMasterCardData.MinorBD;
          this.ModerateBDChartValues = this.KPIMasterCardData.ModerateBD;
          this.MajorBDChartValues = this.KPIMasterCardData.MajorBD;
        },
        (err: any) => {
          this.toaster.error('error', err.message);
          this.spinner.hide();
        }
      );
    }
  }
  findMTTRTechnicianData(arr, key) {
    let technicianData = [];

    arr.forEach((record) => {
      const technician = technicianData.find(
        (data) => data[key] === record[key]
      );

      if (technician) {
        technician['diffMins'] += record['diffMins'];
        technician['occurrence']++;
      } else {
        let techData = {};
        techData[key] = record[key];
        techData['diffMins'] = record['diffMins'];
        techData['occurrence'] = 1;
        technicianData.push(techData);
      }
    });

    return technicianData;
  }

  findOcc(arr, key) {
    let arr2 = [];

    arr.forEach((x) => {
      if (
        arr2.some((val) => {
          return val[key] == x[key];
        })
      ) {
        arr2.forEach((k) => {
          if (k[key] === x[key]) {
            k['occurrence']++;
          }
        });
      } else {
        let a = {};
        a[key] = x[key];
        a['occurrence'] = 1;
        arr2.push(a);
      }
    });

    return arr2;
  }

  setData() {
    if (this.rawbdCategoryData && this.rawbdCategoryData.length) {
      this.bdCategoryData = [];
      this.rawbdCategoryData.map((res: any) => {
        this.bdCategoryData.push({ y: res.occurrence, name: res.WOName });
      });
    }
    if (
      this.rawmajorBDMachineLevelData &&
      this.rawmajorBDMachineLevelData.length
    ) {
      this.majorBDMachineLevelData = [];
      this.majorBDMachineLevelLabelData = [];
      this.rawmajorBDMachineLevelData.map((res: any) => {
        this.majorBDMachineLevelData.push(res.occurrence);
        this.majorBDMachineLevelLabelData.push(res.PU_Desc);
      });
    }
    if (this.rawsubAssemblyData && this.rawsubAssemblyData.length) {
      this.majorBDSubAssemblyLevelData = [];
      this.majorBDSubAssemblyLevelLabel = [];

      this.rawsubAssemblyData.map((res: any) => {
        this.majorBDSubAssemblyLevelData.push(res.occurrence);
        this.majorBDSubAssemblyLevelLabel.push(res.SAsbly_Desc);
      });
    }
    if (this.rawComponentName && this.rawComponentName.length) {
      this.totalBDComponentLevelData = [];
      this.totalBDComponentLevelLabel = [];
      this.rawComponentName.map((res: any) => {
        this.totalBDComponentLevelData.push(res.occurrence);
        this.totalBDComponentLevelLabel.push(res.ComponentName);
      });
    }
    if (this.rawTechnicianName && this.rawTechnicianName.length) {
      this.mttrTechnicianLevelData = [];
      this.mttrTechnicianLevelLabel = [];

      this.rawTechnicianName.forEach((technician) => {
        const averageDiffMin =
          technician['diffMins'] / technician['occurrence'];
        this.mttrTechnicianLevelData.push(averageDiffMin);
        this.mttrTechnicianLevelLabel.push(technician['TechnicianName']);
      });
    }

    if (this.rawFailureName && this.rawFailureName.length) {
      this.repeatedBDLabels = [];
      this.repeatedBDData = [];

      this.rawFailureName.map((res: any) => {
        if (res.occurrence > 1) {
          this.repeatedBDLabels.push(res.FailureName);
          this.repeatedBDData.push(res.occurrence);
        }
      });
    }
    this.mttrMonthlyValues = [];
    const monthName = (item) =>
      moment(item.CreatedAt, 'YYYY-MM-DD').format('MMM');
    const result = _.groupBy(this.rowData, monthName);
    if (result.Jan && result.Jan.length) {
      const sum = result.Jan.reduce((accumulator, object) => {
        return accumulator + object.diffMins;
      }, 0);
      this.mttrMonthlyValues.push(sum / result.Jan.length);
    } else {
      this.mttrMonthlyValues.push(0);
    }
    if (result.Feb && result.Feb.length) {
      const sum = result.Feb.reduce((accumulator, object) => {
        return accumulator + object.diffMins;
      }, 0);
      this.mttrMonthlyValues.push(sum / result.Feb.length);
    } else {
      this.mttrMonthlyValues.push(0);
    }
    if (result.Mar && result.Mar.length) {
      const sum = result.Mar.reduce((accumulator, object) => {
        return accumulator + object.diffMins;
      }, 0);
      this.mttrMonthlyValues.push(sum / result.Mar.length);
    } else {
      this.mttrMonthlyValues.push(0);
    }
    if (result.Apr && result.Apr.length) {
      const sum = result.Apr.reduce((accumulator, object) => {
        return accumulator + object.diffMins;
      }, 0);
      this.mttrMonthlyValues.push(sum / result.Apr.length);
    } else {
      this.mttrMonthlyValues.push(0);
    }
    if (result.May && result.May.length) {
      const sum = result.May.reduce((accumulator, object) => {
        return accumulator + object.diffMins;
      }, 0);
      this.mttrMonthlyValues.push(sum / result.May.length);
    } else {
      this.mttrMonthlyValues.push(0);
    }
    if (result.Jun && result.Jun.length) {
      const sum = result.Jun.reduce((accumulator, object) => {
        return accumulator + object.diffMins;
      }, 0);
      this.mttrMonthlyValues.push(sum / result.Jun.length);
    } else {
      this.mttrMonthlyValues.push(0);
    }
    if (result.Jul && result.Jul.length) {
      const sum = result.Jul.reduce((accumulator, object) => {
        return accumulator + object.diffMins;
      }, 0);
      this.mttrMonthlyValues.push(sum / result.Jul.length);
    } else {
      this.mttrMonthlyValues.push(0);
    }
    if (result.Aug && result.Aug.length) {
      const sum = result.Aug.reduce((accumulator, object) => {
        return accumulator + object.diffMins;
      }, 0);
      this.mttrMonthlyValues.push(sum / result.Aug.length);
    } else {
      this.mttrMonthlyValues.push(0);
    }
    if (result.Sep && result.Sep.length) {
      const sum = result.Sep.reduce((accumulator, object) => {
        return accumulator + object.diffMins;
      }, 0);
      this.mttrMonthlyValues.push(sum / result.Sep.length);
    } else {
      this.mttrMonthlyValues.push(0);
    }
    if (result.Oct && result.Oct.length) {
      const sum = result.Oct.reduce((accumulator, object) => {
        return accumulator + object.diffMins;
      }, 0);
      this.mttrMonthlyValues.push(sum / result.Oct.length);
    } else {
      this.mttrMonthlyValues.push(0);
    }
    if (result.Nov && result.Nov.length) {
      const sum = result.Nov.reduce((accumulator, object) => {
        return accumulator + object.diffMins;
      }, 0);
      this.mttrMonthlyValues.push(sum / result.Nov.length);
    } else {
      this.mttrMonthlyValues.push(0);
    }
    if (result.Dec && result.Dec.length) {
      const sum = result.Dec.reduce((accumulator, object) => {
        return accumulator + object.diffMins;
      }, 0);
      this.mttrMonthlyValues.push(sum / result.Dec.length);
    } else {
      this.mttrMonthlyValues.push(0);
    }

    const mttrCategoryGroup = _.mapValues(
      _.groupBy(this.rowData, 'WOName'),
      (clist) => clist.map((car) => _.omit(car, 'make'))
    );
    let x: any;
    this.mttrCategorySumValue = [];
    for (x in mttrCategoryGroup) {
      const mttrcategorysum = mttrCategoryGroup[x].reduce(
        (accumulator, object) => {
          return accumulator + object.diffMins;
        },
        0
      );

      this.mttrCategorySumValue.push({ name: x, y: mttrcategorysum });
    }

    this.setMajorData();
  }

  setMajorData() {
    const monthName = (item) =>
      moment(item.CreatedAt, 'YYYY-MM-DD').format('MMM');
    this.majorMonthlyValues = [];
    const majorvalues = [];
    if (this.MajorBDRowData && this.MajorBDRowData.length) {
      this.MajorBDRowData.map((res: any) => {
        majorvalues.push(res);
      });
    }
    if (majorvalues && majorvalues.length) {
      const result = _.groupBy(majorvalues, monthName);
      if (result.Jan && result.Jan.length) {
        this.majorMonthlyValues.push(result.Jan.length);
      } else {
        this.majorMonthlyValues.push(0);
      }
      if (result.Feb && result.Feb.length) {
        this.majorMonthlyValues.push(result.Feb.length);
      } else {
        this.majorMonthlyValues.push(0);
      }
      if (result.Mar && result.Mar.length) {
        this.majorMonthlyValues.push(result.Mar.length);
      } else {
        this.majorMonthlyValues.push(0);
      }
      if (result.Apr && result.Apr.length) {
        this.majorMonthlyValues.push(result.Apr.length);
      } else {
        this.majorMonthlyValues.push(0);
      }
      if (result.May && result.May.length) {
        this.majorMonthlyValues.push(result.May.length);
      } else {
        this.majorMonthlyValues.push(0);
      }
      if (result.Jun && result.Jun.length) {
        this.majorMonthlyValues.push(result.Jun.length);
      } else {
        this.majorMonthlyValues.push(0);
      }
      if (result.Jul && result.Jul.length) {
        this.majorMonthlyValues.push(result.Jul.length);
      } else {
        this.majorMonthlyValues.push(0);
      }
      if (result.Aug && result.Aug.length) {
        this.majorMonthlyValues.push(result.Aug.length);
      } else {
        this.majorMonthlyValues.push(0);
      }
      if (result.Sep && result.Sep.length) {
        this.majorMonthlyValues.push(result.Sep.length);
      } else {
        this.majorMonthlyValues.push(0);
      }
      if (result.Oct && result.Oct.length) {
        this.majorMonthlyValues.push(result.Oct.length);
      } else {
        this.majorMonthlyValues.push(0);
      }
      if (result.Nov && result.Nov.length) {
        this.majorMonthlyValues.push(result.Nov.length);
      } else {
        this.majorMonthlyValues.push(0);
      }
      if (result.Dec && result.Dec.length) {
        this.majorMonthlyValues.push(result.Dec.length);
      } else {
        this.majorMonthlyValues.push(0);
      }
      this.majorCategoryValues = [];
      let majorCategoryData = this.findOcc(this.MajorBDRowData, 'WOName');
      majorCategoryData.map((res: any) => {
        this.majorCategoryValues.push({ y: res.occurrence, name: res.WOName });
      });
    }
  }

  toggleAllSelectionUnit() {
    if (this.allSelectedUnit.selected) {
      const allUnits = this.filteredUnits.map((x) => x.PU_Id);
      this.HeaderForm.controls.unit.patchValue(['ALL', ...allUnits]);
    } else {
      this.HeaderForm.controls.unit.patchValue([]);
    }
  }

  tosslePerOneUnit() {
    if (this.allSelectedUnit.selected) {
      this.allSelectedUnit.deselect();
      return;
    }
    if (
      this.HeaderForm.controls.unit.value.length == this.filteredUnits.length
    ) {
      const allUnits = this.filteredUnits.map((x) => x.PU_Id);
      this.HeaderForm.controls.unit.patchValue(['ALL', ...allUnits]);
    }
  }

  toggleAllSelectionLine() {
    if (this.allSelectedLine.selected) {
      const allLines = this.LineFilterList.map((x) => x.PL_Id);
      this.HeaderForm.controls.line.patchValue(['ALL', ...allLines]);
    } else {
      this.HeaderForm.controls.line.patchValue([]);
    }
    this.getUnits();
  }

  tosslePerOneLine() {
    if (this.allSelectedLine.selected) {
      this.allSelectedLine.deselect();
      return;
    }
    if (
      this.HeaderForm.controls.line.value.length == this.LineFilterList.length
    ) {
      const allLines = this.LineFilterList.map((x) => x.PL_Id);
      this.HeaderForm.controls.line.patchValue(['ALL', ...allLines]);
    }
    this.getUnits();
  }
}
